import CryptoJS from 'crypto-js'

const REACT_APP_ENCRYPTION_SECRET = process.env.REACT_APP_ENCRYPTION_SECRET

// Encrypt function (URL-safe)
export const encryptData = (id) => {
  if (!id) return
  const encrypted = CryptoJS.AES.encrypt(id.toString(), REACT_APP_ENCRYPTION_SECRET).toString()
  return encrypted.replace(/\//g, '_').replace(/\+/g, '-').replace(/=+$/, '')
}

// Decrypt function
export const decryptData = (hashedValue) => {
  if (!hashedValue) return null
  // Convert back to original Base64 format before decryption
  let base64 = hashedValue.replace(/_/g, '/').replace(/-/g, '+')
  while (base64.length % 4) {
    base64 += '=' // Pad if necessary
  }

  const bytes = CryptoJS.AES.decrypt(base64, REACT_APP_ENCRYPTION_SECRET)
  return bytes.toString(CryptoJS.enc.Utf8)
}
